import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Input } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';

import GetField from '../Components/GetField';
import stylesCSS from '../styles';
import {
  getTotal,
  getProductTotalA,
  getProductTotalB,
  getProductTotalC,
} from './common-functions';

const AntInput = GetField(Input);

const FabricForm = props => {
  const {
    classes,
    getValues,
    setValue,
    control,
    watch,
    fabricItem,
    fabricIndex,
    fabricAppend,
    fabricRemove,
    styleIndex,
  } = props;

  useEffect(() => {
    const greigePrice =
      getValues(`styles[${styleIndex}].fabrics[${fabricIndex}].greigePrice`) ||
      0;
    const gstPercentage =
      getValues(
        `styles[${styleIndex}].fabrics[${fabricIndex}].gstPercentage`
      ) || 0;
    const shrinkage =
      getValues(`styles[${styleIndex}].fabrics[${fabricIndex}].shrinkage`) || 0;
    const dying =
      getValues(`styles[${styleIndex}].fabrics[${fabricIndex}].dying`) || 0;
    const printing =
      getValues(`styles[${styleIndex}].fabrics[${fabricIndex}].printing`) || 0;

    const gstValue = +((+greigePrice * +gstPercentage) / 100).toFixed(2);
    const amount = +(+greigePrice + +gstValue).toFixed(2) || 0;
    const shrinkageValue = +((+amount * +shrinkage) / 100).toFixed(2);
    const total = +(
      +amount + +shrinkageValue + +dying + +printing || 0
    ).toFixed(2);

    setValue(`styles[${styleIndex}].fabrics[${fabricIndex}].amount`, amount);
    setValue(`styles[${styleIndex}].fabrics[${fabricIndex}].total`, total);
  }, [
    watch(`styles[${styleIndex}].fabrics[${fabricIndex}].greigePrice`),
    watch(`styles[${styleIndex}].fabrics[${fabricIndex}].gstPercentage`),
    watch(`styles[${styleIndex}].fabrics[${fabricIndex}].shrinkage`),
    watch(`styles[${styleIndex}].fabrics[${fabricIndex}].dying`),
    watch(`styles[${styleIndex}].fabrics[${fabricIndex}].printing`),
  ]);

  useEffect(() => {
    const fabrics = getValues(`styles[${styleIndex}].fabrics`);
    const positions = getValues(`styles[${styleIndex}].positions`);
    const processes = getValues(`styles[${styleIndex}].processes`);

    setValue(
      `styles[${styleIndex}].total`,
      getTotal(fabrics, positions, processes)
    );

    const styles = getValues(`styles`);
    setValue(`productTotalA`, getProductTotalA(styles));
    setValue(`productTotalB`, getProductTotalB(styles));
    setValue(`productTotalC`, getProductTotalC(styles));
  }, [watch(`styles[${styleIndex}].fabrics[${fabricIndex}].total`)]);

  // useEffect(() => {
  //   const positions = getValues(`styles[${styleIndex}].positions`);

  //   positions.forEach((position, index) => {
  //     setValue(`styles[${styleIndex}].positions[${index}].fabric`, null);
  //     setValue(`styles[${styleIndex}].positions[${index}].price`, null);
  //   });
  // }, [
  //   watch(`styles[${styleIndex}].fabrics[${fabricIndex}].fabric`),
  //   watch(`styles[${styleIndex}].fabrics[${fabricIndex}].width`),
  //   watch(`styles[${styleIndex}].fabrics[${fabricIndex}].baseColor`),
  //   watch(`styles[${styleIndex}].fabrics[${fabricIndex}].printColor`),
  //   watch(`styles[${styleIndex}].fabrics[${fabricIndex}].total`),
  // ]);

  return (
    <tr>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].fabric`}
          control={control}
          defaultValue={fabricItem.fabric}
          render={({ field }) => (
            <AntInput
              placeholder="Fabric"
              {...field}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].width`}
          control={control}
          defaultValue={fabricItem.width}
          render={({ field }) => (
            <AntInput
              placeholder="Width"
              {...field}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].baseColor`}
          control={control}
          defaultValue={fabricItem.baseColor}
          render={({ field }) => (
            <AntInput
              placeholder="Base Color"
              {...field}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].printColor`}
          control={control}
          defaultValue={fabricItem.printColor}
          render={({ field }) => (
            <AntInput
              placeholder="Print Color"
              {...field}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].greigePrice`}
          control={control}
          defaultValue={fabricItem.greigePrice}
          render={({ field }) => (
            <AntInput
              placeholder="Greige Price"
              {...field}
              type="number"
              min={0}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].gstPercentage`}
          control={control}
          defaultValue={fabricItem.gstPercentage}
          render={({ field }) => (
            <AntInput
              placeholder="GST (%)"
              {...field}
              type="number"
              min={0}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].amount`}
          control={control}
          defaultValue={fabricItem.amount}
          render={({ field }) => (
            <AntInput
              placeholder="Amount"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].shrinkage`}
          control={control}
          defaultValue={fabricItem.shrinkage}
          render={({ field }) => (
            <AntInput
              placeholder="Shrinkage (%)"
              {...field}
              type="number"
              min={0}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].dying`}
          control={control}
          defaultValue={fabricItem.dying}
          render={({ field }) => (
            <AntInput
              placeholder="Dying"
              {...field}
              type="number"
              min={0}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].printing`}
          control={control}
          defaultValue={fabricItem.printing}
          render={({ field }) => (
            <AntInput
              placeholder="Printing"
              {...field}
              type="number"
              min={0}
              size="small"
              onChange={value => {
                field.onChange(value);

                const positions = getValues(`styles[${styleIndex}].positions`);

                positions.forEach((position, index) => {
                  setValue(
                    `styles[${styleIndex}].positions[${index}].fabric`,
                    null
                  );
                  setValue(
                    `styles[${styleIndex}].positions[${index}].price`,
                    null
                  );
                });
              }}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`styles[${styleIndex}].fabrics[${fabricIndex}].total`}
          control={control}
          defaultValue={fabricItem.total}
          render={({ field }) => (
            <AntInput
              placeholder="Total"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <DeleteOutlined
          onClick={() => {
            const fabrics = getValues(`styles[${styleIndex}].fabrics`);

            if (fabrics && fabrics.length > 1) {
              fabricRemove(fabricIndex);
            }

            const positions = getValues(`styles[${styleIndex}].positions`);

            positions.forEach((position, index) => {
              setValue(
                `styles[${styleIndex}].positions[${index}].fabric`,
                null
              );
              setValue(`styles[${styleIndex}].positions[${index}].price`, null);
            });
          }}
        />
        &nbsp; &nbsp;
        <PlusCircleOutlined
          onClick={() => {
            fabricAppend({});

            const positions = getValues(`styles[${styleIndex}].positions`);

            positions.forEach((position, index) => {
              setValue(
                `styles[${styleIndex}].positions[${index}].fabric`,
                null
              );
              setValue(`styles[${styleIndex}].positions[${index}].price`, null);
            });
          }}
        />
      </td>
    </tr>
  );
};

FabricForm.propTypes = {
  classes: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  watch: PropTypes.func.isRequired,
  fabricItem: PropTypes.object.isRequired,
  fabricIndex: PropTypes.number.isRequired,
  fabricAppend: PropTypes.func.isRequired,
  fabricRemove: PropTypes.func.isRequired,
  styleIndex: PropTypes.number.isRequired,
};

export default withStyles(stylesCSS)(FabricForm);
